<template>
  <div id="app" :style="cssVars">

      <div class="cssload-container" v-show="loading_partidos"> <!-- v-show="loading_partidos || ! initial_done" -->
        <div class="lds-dual-ring"></div>
      </div>

      <table v-if="!loading_partidos">
          <tbody>
          <!-- ARRIBA HEADER -->
          <tr>
              <td v-for="phase in phases" :key="phase.phase" class="td-h20"> <!-- round 1 -->
                  <table style="width: 100%;">
                      <tr>
                          <td class="td-2 td-h20" colspan="6">{{ lang == 'es' ? phase.phase_name_es : phase.phase_name_en  }}</td>
                      </tr>
                  </table>
              </td>
          </tr>

          <tr>
              <td v-for="phase in phases" :key="phase.phase" class="td-h20"> <!-- round 1 -->
                  <table style="width: 100%;">
                      <tr>
                          <td class="td-1 td-h20" v-if="phase.phase == 1"></td>
                          <td class="td-2 td-h20"></td>
                          <td class="td-3 td-h20 ida-vuelta">{{ lang == 'es' ? 'IDA': '1st Leg'}}</td>
                          <td class="td-4 td-h20 ida-vuelta">{{ lang == 'es' ? 'VUELTA': '2nd Leg'}}</td>
                          <td class="td-5 td-h20" v-if="phase.phase !== phases.length"></td>
                          <td class="td-6 td-h20" v-if="phase.phase !== phases.length"></td>
                      </tr>
                  </table>
              </td>
          </tr>


          <tr>
              <!-- RONDAS -->

              <td v-for="phase in phases" :key="phase.phase"> <!-- round 1 -->
                  <table style="width: 100%" v-if="phase.phase==1"> <!-- 1ra fase solamente -->
                      <tr v-for="(main_match, index) in phase.matches.slice(0, (phase.matches.length / 2))" :key="main_match.go"> <!-- Arriba phase.matches.length / 2)-->
                          <td class="td-1">
                              <table cellspacing="0" border="0" v-for="match in phase.matches.slice(index * 2, 2 * (index + 1))" :key="match.go">
                                  <tr v-if="!match.winner_only">
                                      <td class="key-number">
                                          <span v-if="index==0"></span> <!-- {{numbers[1]}} -->
                                          <span v-if="index==1"></span> <!-- {{numbers[3]}} -->
                                      </td>
                                  </tr>
                                  <tr v-if="!match.winner_only">
                                      <td class="key-number">
                                          <span v-if="index==0"></span> <!-- {{numbers[2]}} -->
                                          <span v-if="index==1"></span> <!-- {{numbers[4]}} -->
                                      </td>
                                  </tr>
                                  <tr v-if="match.winner_only">
                                      <td class="key-number">
                                          <span v-if="index==0"></span> <!-- {{numbers[0]}} -->
                                          <span v-if="index==1"></span> <!-- {{numbers[5]}} -->
                                      </td>
                                  </tr>
                              </table>
                          </td>
                          <td class="td-2">
                              <table cellspacing="0" border="0" v-for="match in phase.matches.slice(index * 2, 2 * (index + 1))" :key="match.go">
                                  <tr v-if="!match.winner_only">
                                      <td class="key-shield">
                                          <img class="score-shield" :src="match.go_match ? match.go_match.competitors[0].logo : default_shield" width="26" height="26"/>
                                      </td>
                                  </tr>
                                  <tr v-if="!match.winner_only">
                                      <td class="key-shield">
                                          <img class="score-shield" :src="match.go_match ? match.go_match.competitors[1].logo : default_shield" width="26" height="26"/>
                                      </td>
                                  </tr>
                                  <tr v-if="match.winner_only">
                                      <td class="key-shield">
                                          <img class="score-shield" :src="match.winner.logo || default_shield" width="26" height="26"/>
                                      </td>
                                  </tr>

                              </table>
                          </td>

                          <td class="td-3">
                                  <table cellspacing="0" border="0" v-for="match in phase.matches.slice(index * 2, 2 * (index + 1))" :key="match.go">
                                      <tr v-if="!match.winner_only">
                                          <td class="key-score">
                                              <span class="score-box">{{ match.go_match ? (match.go_match.competitors[0].scoreString || '-') : '-' }}</span>
                                          </td>
                                      </tr>
                                      <tr v-if="!match.winner_only">
                                          <td class="key-score">
                                              <span class="score-box">{{ match.go_match ? (match.go_match.competitors[1].scoreString || '-') : '-' }}</span>
                                          </td>
                                      </tr>
                                      <tr v-if="match.winner_only">
                                          <td class="key-score">
                                          </td>
                                      </tr>
                                  </table>
                          </td>
                          <td class="td-4">
                              <table cellspacing="0" border="0" v-for="match in phase.matches.slice(index * 2, 2 * (index + 1))" :key="match.go">
                                  <tr v-if="!match.winner_only">
                                      <td class="key-score">
                                          <span class="score-box">{{ match.back_match ? (match.back_match.competitors[1].scoreString || '-') : '-' }}</span>
                                      </td>
                                  </tr>
                                  <tr v-if="!match.winner_only">
                                      <td class="key-score">
                                          <span class="score-box">{{ match.back_match ? (match.back_match.competitors[0].scoreString || '-') : '-' }}</span>
                                      </td>
                                  </tr>
                                  <tr v-if="match.winner_only">
                                      <td class="key-score">
                                      </td>
                                  </tr>
                              </table>
                          </td>
                          <!-- LLAVE -->
                          <td class="position-relative td-5">
                              <div v-if="index==0" class="key-border" style="border-right: 2px solid #979797; border-bottom: 2px solid #979797; border-top: 2px solid #979797; top: 25%; height: 50%; right: -1px; position: absolute;"></div>
                              <div v-if="index==1" class="key-border" style="border-right: 2px solid #979797; border-bottom: 2px solid #979797; border-top: 2px solid #979797; top: 50%; height: 50%; right: -1px; position: absolute;"></div>

                          </td>
                          <td class="position-relative td-6">
                              <div v-if="index==0" class="key-border" style="border-top: 2px solid #979797; top: 50%; height: 50%; left: -1px; position: absolute;"></div>
                              <div v-if="index==1" class="key-border" style="border-top: 2px solid #979797; top: 34%; height: 50%; left: -1px; position: absolute;"></div>

                          </td>
                      </tr>
                  </table>

                  <table style="width: 100%" v-if="phase.phase!==1"> <!-- Resto de fases 2/3/etc -->
                      <tr> <!-- v-for="(main_match, index) in phase.matches" :key="main_match.go" -->
                          <td class="td-2">
                              <div v-for="(match, index2) in phase.matches" :key="match.go">
                                  <table cellspacing="0" border="0" v-bind:class="{ mb_60: phase.phase !== phases.length && even(index2) }">
                                      <!-- ACA el && index2 es para invertir el primer partido sino quedaria index2 es el primer partido (arriba) o segundo partido (abajo) -->

                                      <tr v-if="!match.winner_only && index2==0">
                                          <td class="key-shield">
                                              <img class="score-shield" :src="match.go_match ? (match.go_match.competitors[1].logo || default_shield) : default_shield" width="26" height="26"/>
                                          </td>
                                      </tr>
                                      <tr v-if="!match.winner_only && index2==0">
                                          <td class="key-shield">
                                              <img class="score-shield" :src="match.go_match ? (match.go_match.competitors[0].logo || default_shield) : default_shield" width="26" height="26"/>
                                          </td>
                                      </tr>

                                      <tr v-if="!match.winner_only && index2==1">
                                          <td class="key-shield">
                                              <img class="score-shield" :src="match.go_match ? (match.go_match.competitors[0].logo || default_shield) : default_shield" width="26" height="26"/>
                                          </td>
                                      </tr>
                                      <tr v-if="!match.winner_only && index2==1">
                                          <td class="key-shield">
                                              <img class="score-shield" :src="match.go_match ? (match.go_match.competitors[1].logo || default_shield) : default_shield" width="26" height="26"/>
                                          </td>
                                      </tr>

                                      <tr v-if="match.winner_only && index2==0"> <!-- index 2 para que es aparezca abajo -->
                                          <td class="key-shield">
                                              <img class="score-shield" :src="match.winner.logo || default_shield" width="26" height="26"/>
                                          </td>
                                      </tr>
                                      <tr v-if="match.winner_only && index2==0">
                                          <td class="key-shield">
                                              <img class="score-shield" :src="default_shield" width="26" height="26"/>
                                          </td>
                                      </tr>

                                      <tr v-if="match.winner_only && index2==1">
                                          <td class="key-shield">
                                              <img class="score-shield" :src="default_shield" width="26" height="26"/>
                                          </td>

                                      </tr>
                                      <tr v-if="match.winner_only && index2==1">
                                          <td class="key-shield">
                                              <img class="score-shield" :src="match.winner.logo || default_shield" width="26" height="26"/>
                                          </td>

                                      </tr>

                                  </table>
                              </div>
                          </td>

                          <td class="td-3">
                              <div v-for="(match, index2) in phase.matches" :key="match.go">
                                  <table cellspacing="0" border="0" v-bind:class="{ mb_60: phase.phase !== phases.length && even(index2) }">
                                      <tr>
                                          <td class="key-score">
                                              <span class="score-box" v-if="index2==0">{{ match.go_match ? (match.go_match.competitors[1].scoreString || '-') : '-' }}</span>

                                              <span class="score-box" v-if="index2==1">{{ match.go_match ? (match.go_match.competitors[0].scoreString || '-') : '-' }}</span>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td class="key-score">
                                              <span class="score-box" v-if="index2==0">{{ match.go_match ? (match.go_match.competitors[0].scoreString || '-') : '-' }}</span>

                                              <span class="score-box" v-if="index2==1">{{ match.go_match ? (match.go_match.competitors[1].scoreString || '-') : '-' }}</span>
                                          </td>
                                      </tr>
<!--                                      <tr v-if="match.winner_only">
                                          <td class="key-score">
                                          </td>
                                      </tr>-->
                                  </table>
                              </div>
                          </td>
                          <td class="td-4">
                              <div v-for="(match, index2) in phase.matches" :key="match.go">
                                  <table cellspacing="0" border="0" v-bind:class="{ mb_60: phase.phase !== phases.length && even(index2) }">
                                      <tr>
                                          <td class="key-score">
                                              <span class="score-box" v-if="index2==0">{{ match.back_match ? (match.back_match.competitors[0].scoreString || '-') : '-' }}</span>

                                              <span class="score-box" v-if="index2==1">{{ match.back_match ? (match.back_match.competitors[1].scoreString || '-') : '-' }}</span>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td class="key-score">
                                              <span class="score-box" v-if="index2==0">{{ match.back_match ? (match.back_match.competitors[1].scoreString || '-') : '-' }}</span>

                                              <span class="score-box" v-if="index2==1">{{ match.back_match ? (match.back_match.competitors[0].scoreString || '-') : '-' }}</span>
                                          </td>
                                      </tr>
                                      <!--
                                      <tr v-if="match.winner_only">
                                          <td class="key-score">
                                          </td>
                                      </tr>
                                      -->
                                  </table>
                              </div>
                          </td>
                          <!-- LLAVE -->
                          <td class="position-relative td-5" v-if="phase.phase !== phases.length">
                              <div class="key-border" style="border-right: 2px solid #979797; border-bottom: 2px solid #979797; border-top: 2px solid #979797; top: 20%; height: 60%; right: -1px; position: absolute;"></div>
                          </td>
                          <td class="position-relative td-6" v-if="phase.phase !== phases.length">
                              <div class="key-border" style="border-top: 2px solid #979797; top: 50%; height: 50%; left: -1px; position: absolute;"></div>
                          </td>
                      </tr>
                  </table>
              </td>

          </tr>


          </tbody>
      </table>
      <table v-if="!loading_partidos && big_final"> <!-- GRAN FINAL -->
          <tbody>
          <tr class="bigfinalrow">
              <td width="50%">
                  <span class="bigfinal">{{ lang=='es' ? big_final.phase_name_es : big_final.phase_name_en }}</span>
              </td>
              <td width="20%">
                  <table>
                      <tr>
                          <td class="td-2">
                              <table>
                                  <tr>
                                      <td class="key-shield">
                                          <img class="score-shield" :src="big_final.matches[0].go_match ? (big_final.matches[0].go_match.competitors[0].logo || default_shield) : default_shield" width="26" height="26"/>
                                      </td>
                                  </tr>
                                  <tr>
                                      <td class="key-shield">
                                          <img class="score-shield" :src="big_final.matches[0].go_match ? (big_final.matches[0].go_match.competitors[1].logo || default_shield) : default_shield" width="26" height="26"/>
                                      </td>
                                  </tr>
                              </table>
                          </td>
                          <td class="td-3">
                              <table>
                                  <tr>
                                      <td class="key-score">
                                          <span class="score-box">{{ big_final.matches[0].go_match ? (big_final.matches[0].go_match.competitors[0].scoreString || '-') : '-' }}</span>
                                      </td>
                                  </tr>
                                  <tr>
                                      <td class="key-score">
                                          <span class="score-box">{{ big_final.matches[0].go_match ? (big_final.matches[0].go_match.competitors[1].scoreString || '-') : '-' }}</span>
                                      </td>
                                  </tr>
                              </table>
                          </td>
                          <td class="td-4">
                              <table>
                                  <tr>
                                      <td class="key-score">
                                          <span class="score-box">{{ big_final.matches[0].back_match ? (big_final.matches[0].back_match.competitors[1].scoreString || '-') : '-' }}</span>
                                      </td>
                                  </tr>
                                  <tr>
                                      <td class="key-score">
                                          <span class="score-box">{{ big_final.matches[0].back_match ? (big_final.matches[0].back_match.competitors[0].scoreString || '-') : '-' }}</span>
                                      </td>
                                  </tr>
                              </table>
                          </td>
                      </tr>
                  </table>
              </td>
              <td width="30%">

              </td>
          </tr>
          </tbody>
      </table>



  </div>
</template>

<script>
    import moment from 'moment-timezone';
    var api_base_url = '';
    const axios = require('axios').default;

    export default {

        components: { }, /* Splide */
        delimiters: ['<%', '%>'],
        props: {lang: String, bgresults: String, cresults: String, bkeys: String, cnumbers: String, cheaders: String, bfinal: String, cfinal: String, league: String, leaguename: String, previewurl: String, liveurl: String, multileague: String, sleaguename: String, sleagueslug: String},
        data: function () {
            return {
                numbers: [],
                all_matches: [],
                next_matches: [],
                phases: [],
                big_final: null,
                current_phase: null,
                ismultileague: false,
                current_league: null,
                leagues: [],
                loading_partidos: true,
                partidos: [],
                initial_done: false,
                interval: null,
                default_shield: require('@/assets/placeholders/placeholder_escudo.svg')
            }
        },
        mounted: function () {
            this.init();
        },
        filters: {
            formatDate: function (value) {
                if (value) {
                    return moment(String(value)).format('DD.MM')
                }
            },
            formatTime: function (value) {
                if (value) {
                    return moment(String(value)).format('HH:mm')
                }
            },
            slce: function (value) {
                if (value) {
                    return value.slice(0,2);
                }
            }
        },
        computed: {
            cssVars() {
                return {
                    '--bgresults': this.bgresults,
                    '--cresults': this.cresults,
                    '--bkeys': this.bkeys,
                    '--cnumbers': this.cnumbers,
                    '--cheaders': this.cheaders,
                    '--bfinal': this.bfinal,
                    '--cfinal': this.cfinal,
                }
            }
        },
        methods: {
            even: function (numero) {
                    return numero % 2 === 0;
            },
            handleInit(event, slick) {
                console.log('handleInit', event, slick);
            },
            changeLeague(){
                this.loading_partidos = true;
/*                api_base_url = 'http://127.0.0.1:8000/ligas/' + this.current_league.value + '/api/'; */

                api_base_url = 'https://gapi.pixeles.club/ligas/' + this.current_league.value + '/api/';

                axios.get(api_base_url+'playoffs?lang='+this.lang).then((response) => {
                    this.numbers = response.data.numbers;
                    this.phases = response.data.phases.filter( f =>  !f.big_final || f.big_final!==true );
                    this.big_final = response.data.phases.filter( f => f.big_final && f.big_final===true );
                    if(this.big_final && this.big_final.length) {
                        this.big_final = this.big_final[0];
                        this.all_matches.forEach((match) => {
                            if (this.big_final.matches[0].go === match.matchId){
                                this.big_final.matches[0].go_match = match;
                            }
                            if (this.big_final.matches[0].back === match.matchId){
                                this.big_final.matches[0].back_match = match;
                            }
                        });
                    }else{
                        this.big_final = undefined;
                    }

                    this.phases.forEach((f)=>{
                        if(f.phase === response.data.current_phase){
                            this.partidos = f.matches;
                            this.current_phase = f;
                        }
                    });

                    /* Si no tengo default pongo como default la 1ra */
                    if(!this.current_phase){
                        this.current_phase = this.phases[0];
                    }
                    this.loading_partidos = false;
                }).catch( error => { console.log(error); });
            },
            init(){
                if(this.multileague==='true'){
                    this.ismultileague = true;
                    console.log('multileague');
/*                    api_base_url = 'http://127.0.0.1:8000/ligas/' + this.league + '/api/'; */
                    api_base_url = 'https://gapi.pixeles.club/ligas/' + this.league + '/api/';
                    this.leagues.push({
                        value: this.league,
                        label: this.leaguename,
                        default: true
                    });
                    this.current_league = this.leagues[0];
                    this.leagues.push({
                        value: this.sleagueslug,
                        label: this.sleaguename,
                        default: false
                    });
                }else{
/*
                    api_base_url = 'http://127.0.0.1:8000/ligas/' + this.league + '/api/';
*/
                    api_base_url = 'https://gapi.pixeles.club/ligas/' + this.league + '/api/';
                }

                axios.get(api_base_url+'matches?nolive=True').then((response) => {
                    this.all_matches = response.data.all_matches;
                    this.next_matches = response.data.all_matches.filter((m)=>{
                        return m.roundNumber === Number(response.data.current_round);
                    });

                    axios.get(api_base_url+'playoffs?lang='+this.lang).then((response) => {
                        console.log(response);
                        this.numbers = response.data.numbers;
                        this.phases = response.data.phases.filter( f =>  !f.big_final || f.big_final!==true );
                        this.big_final = response.data.phases.filter( f => f.big_final && f.big_final===true );
                        if(this.big_final && this.big_final.length) {
                            this.big_final = this.big_final[0];

                            this.all_matches.forEach((match) => {
                                if (this.big_final.matches[0].go === match.matchId){
                                    this.big_final.matches[0].go_match = match;
                                }
                                if (this.big_final.matches[0].back === match.matchId){
                                    this.big_final.matches[0].back_match = match;
                                }
                            });

                        }else{
                            this.big_final = undefined;
                        }
                        console.log(this.phases);
                        console.log('big final');
                        console.log(this.big_final);
                        this.phases.forEach((f)=>{
                            if(f.phase === response.data.current_phase){
                                this.partidos = f.matches;
                                this.current_phase = f;
                            }
                        });

                        /* Si no tengo default pongo como default la 1ra */
                        if(!this.current_phase){
                            this.current_phase = this.phases[0];
                        }

                        let pmp = 0;
                        console.log('all matches');
                        console.log(this.all_matches);
                        this.phases.forEach((phase) => {
                            let pmc = 0;
                            phase.matches.forEach((pm) => {
                                this.all_matches.forEach((match) => {
                                    if (pm.go === match.matchId){
                                        this.phases[pmp].matches[pmc].go_match = match;
                                    }
                                    if (pm.back === match.matchId){
                                        this.phases[pmp].matches[pmc].back_match = match;
                                    }
                                });
                                pmc = pmc + 1;
                            });
                            pmp = pmp + 1;
                        });


                        console.log(this.current_phase);
                        console.log('phases:');
                        console.log(this.phases);
                        this.loading_partidos = false;
                    }).catch( error => { console.log(error); });

                }).catch( error => { console.log(error); });


            },
        }
    }
</script>

<style type="text/scss" lang="scss">
    @import "./assets/css/bootstrap.min.css";
    @import "./assets/css/main.module.css";
    :root {
      padding: 20px;
        font-size: 1vw;
    }

    .score-box {
        background: var(--bgresults);
        color: var(--cresults);
        padding: 10px;
        border: 1px solid var(--bgresults);
        width: 10px !important;
        height: 10px !important;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        border-radius: 2px;
        padding-top: 18px;
        padding-bottom: 18px;
        font-weight: 600;
    }

    .hline {
        border-top: 2px solid var(--bkeys);
        left: -2px;
        position: absolute;
        top: 50%;
        width: 100%;
    }
    .position-relative {
        position: relative;
    }
    table {
        width: 100%;
    }
    td {
        text-align: center;
        height: 60px;
    }
    .clock {
        border: 1px solid gray;
        padding: 2px;
        font-size: 12px;
        display: block;
    }
    .livetd {
        height: 16px !important;
    }
    .livetext {
        color: green;
        font-size: 12px;
    }
    .td-1 {
        width: 10%;

    }
    .td-2 {
        width: 20%;

    }
    .td-3 {
        width: 20%;

    }
    .td-4 {
        width: 20%;

    }
    .td-5 {
        width: 15%;
        /*
                width: 30px;
        */
    }
    .td-6 {
        width: 15%;

        /*
                width: 30px;
        */
    }
    .td-h20 {
        height: 20px !important;
    }
    .ida-vuelta {
        font-size: 12px;
        font-weight: 600;
        color: var(--cheaders);

    }
    .bigfinal {
        font-size: 20px;
        font-weight: 600;
        color: var(--cfinal);
    }
    .bigfinalrow {
        background: var(--bfinal);
    }
    .key-number {
        color: var(--cnumbers);
        font-weight: 600;
        font-size: 12px;
    }
    .mb_60 {
        margin-bottom: 60px;
    }


    .key-border {
        width: 20px;
    }

    @media (max-width: 1900px) {
        .key-border {
            width: 5px;
        }
    }

</style>
